import { render, staticRenderFns } from "./cardRoutes.vue?vue&type=template&id=9f6ecb3c"
import script from "./cardRoutes.vue?vue&type=script&lang=js"
export * from "./cardRoutes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports